import styled from 'styled-components';

export const SectionTitle = styled.div`
  margin: 30px 0 20px;
  font-size: 14px;
  text-transform: uppercase;
  color: var(--white-60);
`;

export const Row = styled.div`
  display: flex;
  gap: 30px;

  > * {
    flex: 1 1 0;
  }
`;

export const MutedText = styled.div`
  color: var(--white-60);
`;

export const Source = styled(MutedText)`
  margin-top: 10px;
  font-size: 12px;
`;
